import {
  FETCH_CATEGORY_NAVIGATIONS_PENDING,
  FETCH_CATEGORY_NAVIGATIONS_FULFILLED,
  FETCH_CATEGORY_NAVIGATIONS_REJECTED,
  FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_PENDING,
  FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_FULFILLED,
  FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_REJECTED,
} from "../actions/categoryNavigation";

const initialState = {
  categoryNavigations: [],
  currentNavigation: null,
  loading: false,
  error: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CATEGORY_NAVIGATIONS_PENDING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CATEGORY_NAVIGATIONS_FULFILLED:
      return {
        ...state,
        categoryNavigations: payload,
        loading: false,
        error: null,
      };

    case FETCH_CATEGORY_NAVIGATIONS_REJECTED:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_PENDING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_FULFILLED:
      return {
        ...state,
        currentNavigation: payload,
        loading: false,
        error: null,
      };

    case FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_REJECTED:
      return {
        ...state,
        loading: false,
        error: payload,
        currentNavigation: null,
      };

    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/store/reducers/categoryNavigation.js